import * as React from "react";
import { SVGProps } from "react";
export const CaretUpIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7.97901 11.667C7.57635 11.667 7.30201 11.4863 7.15601 11.125C7.01068 10.7637 7.07668 10.4443 7.35401 10.167L9.39601 8.125C9.47935 8.04167 9.57668 7.97567 9.68801 7.927C9.79868 7.87833 9.90968 7.854 10.021 7.854C10.1323 7.854 10.2433 7.87833 10.354 7.927C10.4653 7.97567 10.5627 8.04167 10.646 8.125L12.688 10.167C12.9653 10.4443 13.031 10.7637 12.885 11.125C12.7397 11.4863 12.4723 11.667 12.083 11.667H7.97901Z"
            fill="currentColor"
        />
    </svg>
);
CaretUpIcon.displayName = "CaretUpIcon";
